import { GenerateGamesContext } from "./GenerateGamesContext";
import useInitialize from "./useInitialize";
import useExecute from "./useExecute";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";

function useGenerateGamesAction(): any {
  const initialize = useInitialize();
  const initializeFunction = (id: number) => initialize(id);

  const onSuccessExecute = () => {
    setShowModal(false);
  };

  const execute = useExecute();

  const executeFunction = () => execute(onSuccessExecute);

  const { setShowModal } = useContext(GenerateGamesContext);

  const modalConfig = {
    context: GenerateGamesContext,
    title: t("generate_games"),
    onSubmit: () => executeFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t("are_you_sure_you_want_to_generete_the_games_of_this_category?")}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    initializeFunction,
    actionTemplate,
  };
}

export default useGenerateGamesAction;
